import {Redirect, Route} from 'react-router-dom';
import {CancelSubscription} from '../../CancelSubscription.tsx';
import AddWidget from '../../configuration/AddWidget';
import Configuration from '../../configuration/Configuration';
import {EditContainer} from '../../configuration/edit/EditContainer';
import {Dashboard} from '../../dashboard/Dashboard';
import {ExportV2} from '../../export/ExportV2';
import {WebHookEditRouter} from '../../integrations/edit/webhook/WebHookEditRouter';
import {WebHooks} from '../../integrations/WebHooks';
import {Keys} from '../../keys/Keys';
import {YearlyReportV2Container} from '../../report/2022/dashboardContainer/YearlyReportV2Container';
import {ProfileSettings} from '../../settings/ProfileSettings';
import {CloneWidget} from '../../configuration/CloneWidget';
import {ReportsV2} from '../../reportsV2/ReportsV2';
import {ReportsV2View} from '../../reportsV2/ReportsV2View/ReportsV2View';
import {MIDIPage} from '../../midi/MIDIPage';
import {MIDI} from '../../midi/MIDI';
import {Setup} from '../../setup/Setup';
import {TwitchExtensionConfigurationComponent} from '../../twitchExtensionConfiguration/TwitchExtensionConfiguration';
import {TwitchExtensionConnectComponent} from '../../twitchExtensionConfiguration/TwitchExtensionConnectComponent';

export const DASHBOARD_ROUTES = {
  DASHBOARD: '/ui/dashboard',
  REDEEM_COUPON: '/ui/dashboard/redeem-coupon',

  CONFIGURATION: '/ui/configuration',
  CONFIGURATION_EDIT_WIDGET: '/ui/configuration/:id/edit',
  CONFIGURATION_ADD_WIDGET: '/ui/configuration/:predefinedWidgetId/add',
  CONFIGURATION_CLONE_WIDGET: '/ui/configuration/:predefinedWidgetId/clone',
  EXPORT: '/ui/export',
  ANALYTICS: '/ui/analytics',
  WELCOME_FIRST: '/ui/welcome-first',
  WELCOME: '/ui/welcome',
  THANK_YOU: '/ui/thank-you',
  KEYS: '/ui/keys',
  VODS: '/ui/vods',
  REPORTS: '/ui/reports',
  REPORTS_VIEW: '/ui/reports/:id',
  INTEGRATIONS: '/ui/integrations',
  INTEGRATIONS_EDIT: '/ui/integrations/:id/edit',
  YEARLY_REPORT: '/ui/yearly',
  CANCEL_SUBSCRIPTION: '/ui/cancel-subscription',
  PROFILE_SETTINGS: '/ui/profile/settings',
  MIDI: '/ui/midi',
  TWITCH_EXTENSION_CONFIGURATION: '/ui/twitch-extension-configuration',
  TWITCH_EXTENSION_CONNECT: '/ui/twitch-extension-configuration/connect',
};

export const PrivateRoutes = () => {
  return (
    <>
      <Route path={DASHBOARD_ROUTES.DASHBOARD} component={Dashboard} />

      <Route
        path={DASHBOARD_ROUTES.CONFIGURATION}
        exact
        component={Configuration}
      />
      <Route
        path={DASHBOARD_ROUTES.CONFIGURATION_EDIT_WIDGET}
        exact
        component={EditContainer}
      />
      <Route
        path={DASHBOARD_ROUTES.CONFIGURATION_ADD_WIDGET}
        exact
        component={AddWidget}
      />
      <Route
        path={DASHBOARD_ROUTES.CONFIGURATION_CLONE_WIDGET}
        exact
        component={CloneWidget}
      />

      <Route path={DASHBOARD_ROUTES.EXPORT} exact component={ExportV2} />
      <Route path={DASHBOARD_ROUTES.WELCOME_FIRST} exact component={Setup} />
      <Route path={DASHBOARD_ROUTES.WELCOME} exact component={Setup} />

      <Route path={DASHBOARD_ROUTES.THANK_YOU} exact component={Setup} />
      <Route path={DASHBOARD_ROUTES.KEYS} exact component={Keys} />
      <Route path={[DASHBOARD_ROUTES.ANALYTICS, DASHBOARD_ROUTES.VODS]} exact>
        <Redirect to={DASHBOARD_ROUTES.REPORTS} />
      </Route>
      <Route path={DASHBOARD_ROUTES.REPORTS} exact component={ReportsV2} />
      <Route
        path={DASHBOARD_ROUTES.REPORTS_VIEW}
        exact
        component={ReportsV2View}
      />
      <Route path={DASHBOARD_ROUTES.INTEGRATIONS} exact component={WebHooks} />
      <Route
        path={DASHBOARD_ROUTES.INTEGRATIONS_EDIT}
        exact
        component={WebHookEditRouter}
      />
      <Route
        path={DASHBOARD_ROUTES.YEARLY_REPORT}
        exact
        component={YearlyReportV2Container}
      />
      <Route
        path={DASHBOARD_ROUTES.CANCEL_SUBSCRIPTION}
        exact
        component={CancelSubscription}
      />
      <Route
        path={DASHBOARD_ROUTES.PROFILE_SETTINGS}
        exact
        component={ProfileSettings}
      />
      <Route path={DASHBOARD_ROUTES.MIDI} exact component={MIDIPage} />
      <Route
        path={DASHBOARD_ROUTES.TWITCH_EXTENSION_CONFIGURATION}
        exact
        component={TwitchExtensionConfigurationComponent}
      />
      <Route
        path={DASHBOARD_ROUTES.TWITCH_EXTENSION_CONNECT}
        exact
        component={TwitchExtensionConnectComponent}
      />
      <Route path={'/ui/test-midi2'} exact component={MIDI} />
    </>
  );
};
